import { render } from "./ExternalMcpServerInstallDialog.vue?vue&type=template&id=5f2e35f8&scoped=true&ts=true"
import script from "./ExternalMcpServerInstallDialog.vue?vue&type=script&lang=ts"
export * from "./ExternalMcpServerInstallDialog.vue?vue&type=script&lang=ts"

import "./ExternalMcpServerInstallDialog.vue?vue&type=style&index=0&id=5f2e35f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2e35f8"]])

export default __exports__